module.exports = __webpack_public_path__ + "static/media/logo.09ef50f4.png";